import { PF } from '@pages/Clients/NewClientsList/data/constants';
import { Filters } from '@pages/Clients/NewClientsList/ui';

import '@pages/Clients/NewClientsList/styles/NewClientsList.desktop.scss';

export const NewClientsListPage = () => {
  return (
    <div className={PF}>
      <Filters />
    </div>
  );
};
